import React from 'react';
import {
  IonIcon,
  IonLabel,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonRouterOutlet
} from '@ionic/react';
import { card, key, camera } from 'ionicons/icons';
import { connect } from 'react-redux'
import './Profile.css';

import { Route, Redirect } from "react-router";

import UserData from './UserData';
import Password from './Password';
import Photo from './Photo';

import IndexActions from '../../../actions/index';

class Profile extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  closeModal() {
   console.log(this.props)
   //this.props.getMe()
  }

  render() {
    return (
      <IonTabs>

        <IonRouterOutlet>
          <Route path="/profile/userdata" component={UserData}  />
          <Route path="/profile/password" component={Password} />
          <Route path="/profile/photo" component={Photo} />
          <Route path="/" render={() => <Redirect to="/profile/tab2" />} exact={true} /> 
        </IonRouterOutlet>

        <IonTabBar slot="bottom">
          <IonTabButton tab="userdata" href="/profile/userdata">
            <IonIcon icon={card} />
            <IonLabel>Perfil de usuario</IonLabel>
          </IonTabButton>
          <IonTabButton tab="password" href="/profile/password">
            <IonIcon icon={key} />
            <IonLabel>Modificar contraseña</IonLabel>
          </IonTabButton>
          <IonTabButton tab="photo" href="/profile/photo">
            <IonIcon icon={camera} />
            <IonLabel>Foto</IonLabel>
          </IonTabButton>
        </IonTabBar>

      </IonTabs>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMe: () => dispatch(IndexActions.getMe())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
